var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Rain component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconRain extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.82386 16.8C9.19434 16.9853 9.34451 17.4358 9.15927 17.8063L8.37899 19.3668C8.19375 19.7373 7.74325 19.8875 7.37276 19.7022C7.00228 19.517 6.85211 19.0665 7.03735 18.696L7.81763 17.1355C8.00287 16.765 8.45337 16.6148 8.82386 16.8Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.8473 16.8C16.2178 16.9853 16.3679 17.4358 16.1827 17.8063L15.4024 19.3668C15.2172 19.7373 14.7667 19.8875 14.3962 19.7022C14.0257 19.517 13.8755 19.0665 14.0608 18.696L14.8411 17.1355C15.0263 16.765 15.4768 16.6148 15.8473 16.8Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5553 19.9211C11.9258 20.1064 12.076 20.5569 11.8907 20.9274L11.1104 22.4879C10.9252 22.8584 10.4747 23.0086 10.1042 22.8233C9.73372 22.6381 9.58356 22.1876 9.7688 21.8171L10.5491 20.2566C10.7343 19.8861 11.1848 19.7359 11.5553 19.9211Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.53284 19.9211C4.90332 20.1064 5.05349 20.5569 4.86825 20.9274L4.08798 22.4879C3.90273 22.8584 3.45223 23.0086 3.08175 22.8233C2.71126 22.6381 2.56109 22.1876 2.74634 21.8171L3.52661 20.2566C3.71185 19.8861 4.16236 19.7359 4.53284 19.9211Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.5778 19.9211C18.9482 20.1064 19.0984 20.5569 18.9132 20.9274L18.1329 22.4879C17.9477 22.8584 17.4972 23.0086 17.1267 22.8233C16.7562 22.6381 16.606 22.1876 16.7913 21.8171L17.5715 20.2566C17.7568 19.8861 18.2073 19.7359 18.5778 19.9211Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.034 2.61377C8.97666 2.61334 7.76164 4.94611 7.44335 6.10523C7.33531 6.49871 6.93252 6.73361 6.53685 6.6339C4.61682 6.15003 2.73615 7.40889 2.58999 9.53684C2.51841 10.5787 2.94308 11.3632 3.54045 11.9173C4.15019 12.4829 4.90561 12.7736 5.40491 12.8171H18.1142C18.1252 12.8171 18.1361 12.8173 18.1471 12.8178C19.4935 12.8769 21.2858 11.9301 21.4118 9.71738C21.3611 8.3773 20.7463 7.5148 19.9836 7.02311C19.1852 6.50844 18.2115 6.39145 17.4828 6.6019C17.29 6.65759 17.0829 6.63367 16.9078 6.53549C16.7335 6.43772 16.6055 6.27445 16.552 6.08195L16.5515 6.08011L16.5512 6.07907L16.5446 6.05717C16.538 6.03573 16.5269 6.00102 16.5109 5.95494C16.4788 5.86264 16.4274 5.72567 16.3531 5.559C16.2037 5.22384 15.9668 4.77897 15.6183 4.33741C14.9309 3.46636 13.8208 2.61402 12.034 2.61377ZM17.7576 5.02683C17.7465 5.00124 17.7351 4.97507 17.7232 4.94837C17.5368 4.53033 17.2399 3.97091 16.7958 3.40814C15.898 2.27055 14.3877 1.1141 12.0342 1.11377C8.51973 1.11327 6.85684 3.48654 6.21959 5.05741C3.66314 4.78713 1.28823 6.59931 1.09352 9.43404M17.7576 5.02683C18.7616 4.92045 19.868 5.16397 20.7963 5.76237C21.9738 6.52143 22.854 7.84413 22.9122 9.7009C22.9128 9.72117 22.9126 9.74146 22.9116 9.76172C22.751 12.9864 20.0859 14.3955 18.0986 14.3171H5.37539C5.35742 14.3171 5.33945 14.3164 5.32153 14.3151C4.45767 14.2529 3.37151 13.8066 2.52032 13.017C1.64677 12.2067 0.985977 10.9993 1.09352 9.43404"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconRain.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconRain.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconRain.prototype, "size", void 0);
if (customElements.get('cat-icon-rain') === undefined) {
    customElements.define('cat-icon-rain', BlocksIconRain);
}
